module.exports = __webpack_public_path__ + "img/katarina_events_8.fefb4707.jpg";